import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'header.menu.welcome.banner.title',
    defaultMessage: 'Select your location and language',
  },
  locationLabel: {
    id: 'header.menu.welcome.banner.location.label',
    defaultMessage: 'Location',
  },
  submitBtn: {
    id: 'header.menu.welcome.banner.submit.button.text',
    defaultMessage: 'Continue',
  },
});

export default messages;
